"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserConfigProvider = void 0;

var _assert = require("../../utils/assert");

var _getUserConfig = require("./response-parsers/get-user-config");

var _putRecordData = require("./response-parsers/put-record-data");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UserConfigProvider =
/*#__PURE__*/
function () {
  function UserConfigProvider(dataService) {
    _classCallCheck(this, UserConfigProvider);

    this._client = dataService;
  }
  /**
   * Gets the user's config settings. If "component" is specified then only that component's config settings are,
   * returned; otherwise the user's settings are returned grouped by component. The values are type-coerced.
   * @param userId - The ID of the user whose config settings we are requesting
   * @param component - Optional. The component whose user settings we are interested in (e.g. 'uScope')
   * @returns {*}
   */


  _createClass(UserConfigProvider, [{
    key: "getUserConfig",
    value: function getUserConfig(userId, component) {
      // This function uses the "GetFilteredRecordList" API to simulate a real "config" API. We pass in a table name and
      // some filters to get at the data we're interested in.
      _assert.assert.isRequired({
        userId: userId
      });

      _assert.assert.isNumeric({
        userId: userId
      });

      var filters = [{
        $: {
          Column: 'UserId',
          FilterOperator: '=',
          FilterValue: userId,
          Table: 'UserConfig'
        }
      }];

      if (component) {
        filters.push({
          $: {
            Column: 'Component',
            FilterOperator: '=',
            FilterValue: component,
            Table: 'UserConfig'
          }
        });
      }

      return this._client.request({
        methodName: 'GetFilteredRecordList',
        data: {
          TableName: 'UserConfig',
          FilterBy: filters
        },
        parseResponseDelegate: (0, _getUserConfig.createGetUserConfigResponse)(component)
      });
    }
    /**
     * Gets the current value for a config setting's Id
     * @param id
     * @returns {*}
     */

  }, {
    key: "getConfigValue",
    value: function getConfigValue(id) {
      _assert.assert.isRequired({
        id: id
      });

      _assert.assert.isNumeric({
        id: id
      });

      return this._client.request({
        methodName: 'GetFilteredRecordList',
        data: {
          TableName: 'UserConfig',
          FilterBy: [{
            $: {
              Column: 'Id',
              FilterOperator: '=',
              FilterValue: id,
              Table: 'UserConfig'
            }
          }]
        },
        parseResponseDelegate: _getUserConfig.getConfigValueResponse
      });
    }
    /**
     * Creates a new user configuration setting. Returns the requested data along with the Id of any inserted values.
     * @param userId
     * @param component
     * @param name
     * @param value
     * @returns {*}
     */

  }, {
    key: "createConfigValue",
    value: function createConfigValue(_ref) {
      var userId = _ref.userId,
          component = _ref.component,
          name = _ref.name,
          value = _ref.value;

      _assert.assert.isRequired({
        userId: userId,
        component: component,
        name: name,
        value: value
      });

      _assert.assert.isNumeric({
        userId: userId
      });

      return this._client.request({
        methodName: 'PutRecordData',
        data: {
          TableName: 'UserConfig',
          DataRow: {
            UserId: userId,
            Component: component,
            Name: name,
            Value: value
          }
        },
        parseResponseDelegate: (0, _putRecordData.createPutRecordDataResponse)({
          userId: userId,
          component: component,
          name: name,
          value: value
        })
      });
    }
    /**
     * Updates an existing user configuration setting. Returns the original values.
     * @param id
     * @param userId
     * @param component
     * @param name
     * @param value
     * @returns {Promise<*>}
     */

  }, {
    key: "updateConfigValue",
    value: function () {
      var _updateConfigValue = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref2) {
        var id, userId, component, name, value, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref2.id, userId = _ref2.userId, component = _ref2.component, name = _ref2.name, value = _ref2.value;

                _assert.assert.isRequired({
                  id: id,
                  userId: userId,
                  component: component,
                  name: name,
                  value: value
                });

                _assert.assert.isNumeric({
                  id: id,
                  userId: userId
                });

                _context.next = 5;
                return this._client.request({
                  methodName: 'PutRecordData',
                  data: {
                    TableName: 'UserConfig',
                    Id: id,
                    DataRow: {
                      UserId: userId,
                      Component: component,
                      Name: name,
                      Value: value
                    }
                  },
                  parseResponseDelegate: (0, _putRecordData.createPutRecordDataResponse)({
                    userId: userId,
                    component: component,
                    name: name,
                    value: value
                  })
                });

              case 5:
                response = _context.sent;

                if (!(response.data.id !== id)) {
                  _context.next = 8;
                  break;
                }

                throw new Error('New record created from "Update" call.');

              case 8:
                return _context.abrupt("return", response);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function updateConfigValue(_x) {
        return _updateConfigValue.apply(this, arguments);
      };
    }()
    /**
     * Deletes a user configuration setting from the server.
     * @param id
     * @returns {*}
     */

  }, {
    key: "deleteConfigValue",
    value: function deleteConfigValue(id) {
      _assert.assert.isRequired({
        id: id
      });

      _assert.assert.isNumeric({
        id: id
      });

      return this._client.request({
        methodName: 'DeleteRecordData',
        data: {
          TableName: 'UserConfig',
          DataRow: {
            Id: id
          }
        }
      });
    }
  }]);

  return UserConfigProvider;
}();

exports.UserConfigProvider = UserConfigProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/user/UserConfigProvider.js
// module id = 240
// module chunks = 0